export default __webpack_public_path__ + "static/media/member_card_yellow.e7a4f4d4.png";